/* eslint-disable react/jsx-no-target-blank */
import React, { Fragment, useState } from 'react';
import { getBackgroundImg, getPublicImagePath, Modal } from '@nutastic/nutastic-react-app';
import PageHeader from '../PageHeader';
import Fade from 'react-reveal/Fade';

const AboutPage = () => {
    const [showHotels, setShowHotels] = useState(false);
    const pinterestUrl = 'https://www.pinterest.com/russellwendell2020/all-black-formal-wedding-attire/?invite_code=cf946f2b80b24fbd928ab1d0450bb357&sender=83387168009000769';
    const hotelOneUrl = 'https://www.hotelindigo.com/redirect?path=hd&brandCode=IN&localeCode=en&regionCode=1&hotelCode=ATLWW&_PMID=99801505&GPC=PIN&cn=no&viewfullsite=true';
    const hotelTwoUrl = 'https://www.marriott.com/event-reservations/reservation-link.mi?id=1663510527631&key=GRP&app=resvlink';
    const registryUrl = 'https://withjoy.com/chelsi-and-spencer/registry';

    const accommodationContent = <div className="about-modal-content">
        <h5>Hotel Indigo® Atlanta Airport / College Park</h5>
        <p>1776 Harvard Avenue, College Park Georgia 30337</p>
        <p>404.767.8881</p>
        <a href={hotelOneUrl} target="_blank">Click here to book</a>
        <hr />
        <h5>Courtyard by Marriot Atlanta Decatur Downtown/Emory</h5>
        <p>130 Clairemont Ave, Decatur GA 30030</p>
        <p>404.371.0204</p>
        <a href={hotelTwoUrl} target="_blank">Click here to book</a>
        <hr />
        <h5>Canopy Atlanta Midtown</h5>
        <p>1414 West Peachtree Street NW., Atlanta, GA 30309</p>
        <p>404.720.5507</p>
        <i><b>Guests will need to call and mention Pinkett-Johnson wedding room block</b></i>
    </div>;

    return <Fragment>
        <PageHeader
            image={getPublicImagePath('about.jpg')}
            content="View the details about the wedding, accommodations, registry, and more."
            iconClass="ion-ios-information-circle-outline"
            subtitle="Wedding"
            title="Details"
        />

        <section className="flexSection flexSection--flipped">
            <Fade right={true}>
                <div className="flexSection__image" style={getBackgroundImg(getPublicImagePath('ab-1.jpg'))}/>
            </Fade>
            <Fade left={true}>
                <div className="flexSection__details wedding-details background-black">
                    <h2>the date</h2>
                    <p>February 4th, 2023</p>
                    <p>Wedding begins at <b>5:00pm</b></p>
                    <small>Doors will open at 4:30pm and close at 4:55pm, as the ceremony will begin promptly at 5:00pm</small>
                </div>
            </Fade>
        </section>

        <section className="flexSection">
            <Fade left={true}>
                <div className="flexSection__image" style={getBackgroundImg(getPublicImagePath('ab-2.jpg'))}/>
            </Fade>
            <Fade right={true}>
                <div className="flexSection__details wedding-details isBoxed">
                    <h2>the location</h2>
                    <p>Agnes Scott College - Leticia Pate Evans Hall</p>
                    <p>141 E College Ave, Decatur, GA 30030</p>
                    <small>
                        Complimentary guest parking is located in the West Parking Facility located at 137 S. McDonough St., Decatur, GA 30030.
                         There will be signage that will direct guests to the ceremony location.
                    </small>
                </div>
            </Fade>
        </section>

        <section className="flexSection flexSection--flipped about-section">
            <Fade right={true}>
                <div className="flexSection__image" style={getBackgroundImg(getPublicImagePath('ab-3.jpg'))}/>
            </Fade>
            <Fade left={true}>
                <div className="flexSection__details wedding-details background-black">
                    <h2 className="more-space">Guest Info</h2>
                    <p>All guests are to attend the wedding in All-Black, Formal Attire. Please <a href={pinterestUrl} target="_blank">click here</a> to see examples of the required dress code.</p>
                    <small>
                        The wedding is exclusively an all-adult occasion, with all guests being 21 years of age or older.
                         There are no plus ones allowed unless specifically indicated.
                    </small>
                </div>
            </Fade>
        </section>

        <section className="flexSection about-section">
            <Fade left={true}>
                <div className="flexSection__image" style={getBackgroundImg(getPublicImagePath('ab-4.jpg'))}/>
            </Fade>
            <Fade right={true}>
                <div className="flexSection__details wedding-details isBoxed">
                    <h2 className="upper-me">Accommodations</h2>
                    <p>Click the button below to view guest accommodations.</p>
                    <button className="btn btn-primary" onClick={() => setShowHotels(true)}>View More</button>
                </div>
            </Fade>
        </section>

        <section className="flexSection flexSection--flipped about-section">
            <Fade right={true}>
                <div className="flexSection__image" style={getBackgroundImg(getPublicImagePath('ab-5.jpg'))}/>
            </Fade>
            <Fade left={true}>
                <div className="flexSection__details wedding-details background-black">
                    <h2 className="more-space">Registry</h2>
                    <p>You are welcome to provide a wedding gift through our With Joy account, <a href={registryUrl} target="_blank">click here</a> to share the love.</p>
                </div>
            </Fade>
        </section>

        <section className="callToActionFooter">
            <Fade bottom={true}>
                <div className="container">
                    <h2>Invitation Responses</h2>
                    <div className="icon-divider icon-divider--large">
                        <i className="ion-md-paper-plane" />
                    </div>
                    <p>Indicate your RSVP by clicking below.</p>
                    <a href="/reserve" className="btn btn-outline-white">RSVP</a>
                </div>
            </Fade>
        </section>

        <Modal show={showHotels} onClose={() => setShowHotels(false)} title="Guest Accommodations">
            { accommodationContent }
        </Modal>
    </Fragment>;
};

export default AboutPage;
